import { motion } from "framer-motion";
import { Eyebrow } from "@/components/Reveal";

export default function Banner({
  image,
  eyebrow,
  title,
  text,
  children,
  floating,
  testid,
  alt = "",
  full = false,
}) {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section
      className={`grain relative flex overflow-hidden bg-noir ${
        full ? "min-h-[70vh] items-center" : "min-h-[64vh] items-end"
      }`}
    >
      <motion.img
        src={image}
        alt={alt}
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-noir via-noir/70 to-noir/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-noir via-transparent to-noir/50" />

      <div
        className={`relative mx-auto w-full max-w-7xl px-6 lg:px-10 ${
          full ? "pb-16 pt-28 lg:pb-20 lg:pt-32" : "pb-16 pt-40 lg:pb-20"
        }`}
      >
        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="mb-5"
          >
            <Eyebrow>{eyebrow}</Eyebrow>
          </motion.div>
        )}
        <h1
          data-testid={testid}
          className={`font-serif leading-[1.1] text-ivory ${
            full ? "max-w-3xl text-5xl sm:text-6xl lg:text-7xl" : "max-w-2xl text-4xl sm:text-5xl lg:text-6xl"
          }`}
        >
          {lines.map((l, i) => (
            <span key={i} className="block overflow-hidden pb-1">
              <motion.span
                className="block"
                initial={{ y: "112%" }}
                animate={{ y: 0 }}
                transition={{
                  duration: 0.9,
                  delay: 0.2 + i * 0.14,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </h1>
        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.9, delay: 0.55 }}
          className="mt-7 h-px w-16 origin-left bg-gold"
        />
        {text && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.65 }}
            className="mt-7 max-w-xl text-[15px] leading-relaxed text-ivory/85 sm:text-base"
          >
            {text}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="mt-10"
          >
            {children}
          </motion.div>
        )}
      </div>

      {floating}
    </section>
  );
}
